import { Injectable } from '@angular/core';
import { environment, environment_int, environment_stg, environment_prod, Environment } from '../../../environments/environment';

export type EnvironmentType = 'dev' | 'stg' | 'prod';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  
  getCurrentEnvironment(): EnvironmentType {
    const env = document
      .querySelector('meta[name="environment"]')
      ?.getAttribute('value');
    
    switch (env) {
      case 'prod':
        return 'prod';
      case 'stg':
        return 'stg';
      default:
        return 'dev';
    }
  }

  getHigherEnvironment(): EnvironmentType | null {
    const current = this.getCurrentEnvironment();
    
    switch (current) {
      case 'dev':
        return 'stg';
      case 'stg':
        return 'prod';
      case 'prod':
        return null; // No higher environment
      default:
        return null;
    }
  }

  canPromote(): boolean {
    const current = this.getCurrentEnvironment();
    return current === 'dev' || current === 'stg';
  }

  getEnvironmentConfig(envType: EnvironmentType): Environment {
    switch (envType) {
      case 'prod':
        return environment_prod;
      case 'stg':
        return environment_stg;
      case 'dev':
      default:
        return environment_int;
    }
  }

  getCurrentEnvironmentConfig(): Environment {
    return environment;
  }

  getHigherEnvironmentConfig(): Environment | null {
    const higherEnv = this.getHigherEnvironment();
    if (!higherEnv) {
      return null;
    }
    return this.getEnvironmentConfig(higherEnv);
  }

  getEnvironmentDisplayName(envType: EnvironmentType): string {
    switch (envType) {
      case 'dev':
        return 'Development';
      case 'stg':
        return 'Staging';
      case 'prod':
        return 'Production';
      default:
        return envType;
    }
  }
}
